import FormData from "@/module/FormData";

export default class CreateOrderIntent {
  private readonly formUrl: string;
  private readonly path: string;

  constructor(apiUrl: string, path: string) {
    this.formUrl = apiUrl;
    this.path = path;
  }

  create(formData: FormData): Promise<object> {
    const data = JSON.stringify(formData);
    return fetch(this.formUrl + "/create-order-intent?id=" + this.path, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: data,
      credentials: "omit",
    }).then((response) => {
      return response.json();
    });
  }
}
